import { QueryClientProvider } from '@tanstack/react-query';
import 'morpheus-ui/dist/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import queryClient from './core/api/queryClient';
import reportWebVitals from './reportWebVitals';
import ResizeObserver from 'resize-observer-polyfill';

// Prevents the browser from showing the "Install app" banner.
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
});

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
